(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["product-card"] && !Shopify.designMode) return;
  try {
    /* ── Stepper ── */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('.product-card__qty-btn');
    if (!btn) return;
    var input = btn.closest('.product-card__qty-wrap').querySelector('.product-card__qty-input');
    var val = parseInt(input.value, 10) || 1;
    input.value = btn.dataset.action === 'plus' ? val + 1 : Math.max(1, val - 1);
  });

  /* ── Modale panier ── */
  function buildCartModal() {
    if (document.getElementById('cart-modal-overlay')) return;
    var i18nEl = document.getElementById('cart-modal-i18n');
    var i18n = i18nEl ? i18nEl.dataset : {};
    var labelClose = i18n.close || 'Close';
    var labelAdded = i18n.added || 'Added to cart!';
    var labelView = i18n.view || 'View cart';
    var labelContinue = i18n.continue || 'Continue shopping';
    var overlay = document.createElement('div');
    overlay.id = 'cart-modal-overlay';
    overlay.className = 'cart-modal-overlay';
    overlay.setAttribute('hidden', '');
    overlay.setAttribute('role', 'dialog');
    overlay.setAttribute('aria-modal', 'true');
    overlay.innerHTML =
      '<div class="cart-modal">' +
        '<button class="cart-modal__close" aria-label="' + labelClose + '" data-close>&#x2715;</button>' +
        '<div class="cart-modal__check" aria-hidden="true">' +
          '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round">' +
            '<polyline points="20 6 9 17 4 12"/>' +
          '</svg>' +
        '</div>' +
        '<p class="cart-modal__headline">' + labelAdded + '</p>' +
        '<p class="cart-modal__product"></p>' +
        '<div class="cart-modal__actions">' +
          '<a href="/cart" class="cart-modal__btn cart-modal__btn--primary">' + labelView + '</a>' +
          '<button class="cart-modal__btn cart-modal__btn--secondary" data-close>' + labelContinue + '</button>' +
        '</div>' +
      '</div>';
    document.body.appendChild(overlay);

    overlay.addEventListener('click', function (e) {
      if (e.target === overlay) closeCartModal();
    });
    overlay.querySelectorAll('[data-close]').forEach(function (el) {
      el.addEventListener('click', closeCartModal);
    });
  }

  function openCartModal(productTitle) {
    buildCartModal();
    var overlay = document.getElementById('cart-modal-overlay');
    overlay.querySelector('.cart-modal__product').textContent = productTitle || '';
    overlay.removeAttribute('hidden');
    requestAnimationFrame(function () {
      overlay.classList.add('cart-modal-overlay--visible');
    });
    overlay.querySelector('.cart-modal__close').focus();
  }

  function closeCartModal() {
    var overlay = document.getElementById('cart-modal-overlay');
    if (!overlay) return;
    overlay.classList.remove('cart-modal-overlay--visible');
    setTimeout(function () { overlay.setAttribute('hidden', ''); }, 220);
  }

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') closeCartModal();
  });

  /* ── Add to cart ── */
  document.addEventListener('submit', function (e) {
    var form = e.target.closest('.product-card__form');
    if (!form) return;
    e.preventDefault();

    var atc = form.querySelector('.product-card__atc');
    var labelEl = atc.lastChild;
    var originalText = labelEl.textContent.trim();

    atc.disabled = true;
    var i18nEl = document.getElementById('cart-modal-i18n');
    var addingText = (i18nEl && i18nEl.dataset.adding) || '…';
    labelEl.textContent = addingText;

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
      body: new URLSearchParams(new FormData(form))
    })
      .then(function (r) { return r.json(); })
      .then(function (item) {
        labelEl.textContent = originalText;
        atc.disabled = false;

        openCartModal(item.product_title);

        return fetch('/cart.js');
      })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        document.querySelectorAll('[data-cart-count]').forEach(function (el) {
          el.textContent = cart.item_count;
          el.classList.toggle('header__cart-count--hidden', cart.item_count === 0);
        });
      })
      .catch(function () {
        labelEl.textContent = originalText;
        atc.disabled = false;
      });
  });
  } catch(e) { console.error(e); }
})();

})();
